
import React, { Component } from 'react';
import { Modal, Button } from 'reactstrap';
import { ElementsConsumer, PaymentElement } from '@stripe/react-stripe-js';
import Spinner from "react-spinners/ScaleLoader";
import { IoIosCloseCircleOutline } from "react-icons/io"
import * as auditLogManager from '../../../../../utils/auditLog/auditLogManager';
import * as auditConstants from '../../../../../utils/auditLog/auditConstants';

const configurationManager = require('../../../../../utils/config/configurationManager');
const stateManager = require('../../../../../utils/state/stateManager');
const viewUtil = require('../../../../../utils/view/viewUtil');
const formatter = require('../../../../../utils/formatter/formatter');
const basketUtil = require('../../../../../utils/basket/basketUtil');
const logger = require('../../../../../utils/logger/logger');

class StripePaymentComponent extends Component 
{
    constructor(props) 
    {
        super(props);

        this.state = {};
        this.state.isProcessing = false;
    }

    render()
    {
        var caption = `Pay Now - ${formatter.convertToCurrencyFormat(basketUtil.getTotalBasketPrice())}`

        var footerButtonStyle = {
            color: `var(--button-continue-font-color)`,
            background: `var(--button-continue-background-color)`,
            borderColor: `var(--button-continue-background-color)`,
            fontSize: `var(--button-continue-font-size)`,
            paddingLeft: '20px',
            paddingRight: '20px',
            marginRight: '5px',
            paddingTop: '10px',
            paddingBottom: '10px',
            width: '80%',
            borderRadius: 15,
            marginTop: '10px'
        }

        var footer = <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <Button style={footerButtonStyle} disabled={this.state.isProcessing}
                onClick={() =>
                {
                    this.getPayNow();
                }}>{caption}
            </Button>
        </div>;

        var paymentComponentVisibility = "visible";
        var spinnerComponentVisibility = "collapse";
        if (this.state.isProcessing)
        {
            paymentComponentVisibility = "hidden";
            spinnerComponentVisibility = "visible";
        }

        return <Modal isOpen={true} centered >
            <div className='AppBar'>
                <table style={{ width: '100%' }}>
                    <tr>
                        <td style={{ width: '99%' }}>
                            <div style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '5px', paddingBottom: '5px' }}>
                                Payment
                            </div>

                        </td>

                        <td style={{ whiteSpace: 'nowrap' }}>
                            <div style={{ marginTop: '5px', marginLeft: '10px', marginRight: '5px', fontSize: `var(--button-close-size)`, color: `var(--button-close-color)` }}
                                onClick={() =>
                                {
                                    if (this.state.isProcessing)
                                        return;

                                    stateManager.getStore().getState().onCreditCardPaymentDismiss();
                                }}>
                                <IoIosCloseCircleOutline />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div style={{ visibility: paymentComponentVisibility, marginLeft: '20px', marginRight: '20px', marginTop: '20px', marginBottom: '20px' }}>
                    <PaymentElement />
                </div>

                <div style={{ visibility: spinnerComponentVisibility, position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                        Processing Payment
                    </div>
                    <div style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                        <Spinner color={`var(--spinner-color)`} size={40} />
                    </div>
                </div>
            </div>

            {footer}
        </Modal>
    }

    async getPayNow()
    {
        try
        {
            logger.info(`Payment button tapped`, this.getTracingContext());

            viewUtil.clearErrors();
            this.state.isProcessing = true;
            this.setState({});

            const { stripe, elements } = this.props;
            if (!stripe || !elements) 
            {
                // Stripe.js has not yet loaded.
                // Make sure to disable form submission until Stripe.js has loaded.
                this.setState({ isProcessing: false }); 
                return;
            }

            var redirect = 'always';
            basketUtil.persistBasketForStripeReturn();
            const { error } = await stripe.confirmPayment(
                {
                    elements,
                    confirmParams: {
                        return_url: `${configurationManager.getAppConfig().appUrlWebOrdering}/#/confirmation?paymentLinkId=${stateManager.getStore().getState().paymentLinkId || ''}`,
                    },
                    redirect
                }
            );

            if (error) 
            {
                const state = stateManager.getStore().getState();
                const basket = state.basket;
                const sale = basket.order;

                logger.error(`Payment failed for order number: ${sale.number}. Error: ${error.message}`, { ...this.getTracingContext(), error: error, tag: "PaymentFlow" });
                auditLogManager.addCustomerAuditLog(
                    auditConstants.modules.SaleManagement,
                    sale.id,
                    sale.number,
                    auditConstants.actions.sale.paymentFailed,
                    error.message,
                    auditConstants.statuses.Failed
                );
                this.state.isProcessing = false;
                this.setState({});
                viewUtil.showErrorAlert(error.message);
            }
        }
        catch (error)
        {
            const state = stateManager.getStore().getState();
            const basket = state.basket;

            logger.error(`Catch Block - Payment failed for order number: ${basket.order.number}. Error: ${JSON.stringify(error)}`, { ...this.getTracingContext(), error: error, tag: "PaymentFlow" });

            this.state.isProcessing = false;
            this.setState({});
            viewUtil.showErrorAlert(error?.message);
        }
    }

    getTracingContext()
    {
        const state = stateManager.getStore().getState();
        const basket = state.basket;

        return {
            franchisorId: state.franchisorId,
            franchiseeId: state.franchiseeId,
            propertyId: state.propertyId,
            orderId: basket.order.id,
            orderNumber: basket.order.number,
            amount: basketUtil.getTotalBasketPrice()
        }
    }
}

export default function InjectedCheckoutForm() 
{
    return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <StripePaymentComponent stripe={stripe} elements={elements} />
            )}
        </ElementsConsumer>
    )
}